import React, {ChangeEvent, useState} from 'react';
import b_ from 'b_';

import I18N from 'assets/i18n/brandlift-project';


import {useSurveySettings, useUpdateSurveySettings} from 'client/common/hooks/survey';
import {useCanEditSurveySettings} from 'client/common/hooks/edit-mode';

import BlockInput from 'client/common/components/block-input';
import {Tumbler} from 'client/common/components/lego';
import {useSurveySlug} from 'client/common/contexts/slug';

const b = b_.with('edit-settings-modal');

const i18n = I18N.common.surveySettings.editSettingsModal;

export default function SettingsRedirect() {
    const slug = useSurveySlug();

    const settings = useSurveySettings();
    const canEdit = useCanEditSurveySettings();
    const onUpdate = useUpdateSurveySettings(slug);

    const [isRedirectDisabled, setRedirectDisabled] = useState(
        settings?.redirects.isDisabled
    );

    const handleRedirectDisabledChange = async (event: ChangeEvent<HTMLInputElement>) => {
        const isDisabled = !event.target.checked;

        setRedirectDisabled(isDisabled);

        const redirect = settings?.redirects.default;

        await onUpdate({
            ...(isDisabled !== undefined && {redirects: {default: redirect ?? '', isDisabled}})
        });
    };

    return (
        <BlockInput className={b('input-wrapper')}>
            <Tumbler
                className={b('tumbler')}
                checked={Boolean(!isRedirectDisabled)}
                labelAfter={i18n.redirect.isDisabled}
                onChange={handleRedirectDisabledChange}
                disabled={!canEdit}
                size='m'
                view='dl'
            />
        </BlockInput>
    );
}
